import { queryKindApi } from '@eastcoal/api/system/kind/queryKind'

import { pick } from '@eastcoal/common/utils/object'

import { onFieldInputValueChange } from '@eastcoal/formily/exports/core'

import { KIND_FIELD } from '../../constants/filed'

export const kindEffects = () => {
  onFieldInputValueChange(KIND_FIELD, async field => {
    const kindId = field.value?.id

    if (!kindId) {
      return
    }

    const kindEntity = await queryKindApi({ id: kindId })

    field
      .query('listingItemList')
      .take()
      ?.setState(state => {
        state.value = kindEntity.quotas?.map(quotas =>
          pick(quotas, ['name', 'unit'])
        )
      })
  })
}
